export const AUTH_CLIENT_PROTOCOL = "wc";
export const AUTH_CLIENT_VERSION = 1;
export const AUTH_CLIENT_CONTEXT = "auth";
export const AUTH_CLIENT_DEFAULT_NAME = "authClient";

export const AUTH_CLIENT_STORAGE_PREFIX = `${AUTH_CLIENT_PROTOCOL}@${AUTH_CLIENT_VERSION}:${AUTH_CLIENT_CONTEXT}:`;
export const AUTH_CLIENT_PUBLIC_KEY_NAME = `${AUTH_CLIENT_STORAGE_PREFIX}:PUB_KEY`;
